
export default {
    rejected: {
        borderStyle: 'solid',
        borderColor: '#c66',
        backgroundColor: '#eee'
    },
    disabled: {
        opacity: 0.5
    },
    active: {
        width: "auto",
        borderStyle: 'solid',
        borderColor: '#6c6',
        backgroundColor: '#eee',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    default: {
        width: "auto",
        height: 200,
        padding: 5,
        borderWidth: 2,
        borderColor: '#666',
        borderStyle: 'dashed',
        borderRadius: 5,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    text: {
        color: '#666',
        width: '100%'
    },
    listItem: {
        color: '#666',
        width: '100%'
    },
    ul: {
        padding: '0'
    }
};


// WEBPACK FOOTER //
// ./src/components/dropzone-style.ts